import * as routeConstants from "./const/route/Route";

export default {
  items: [
    {
      name: 'QR Check-in',
      url: `${routeConstants.HR_ROUTE_PATH}/dashboard`,
      icon: 'icon-chart',
    },
    {
      name: "Branches",
      url: `${routeConstants.HR_ROUTE_PATH}/branches`,
      icon: 'icon-list'
    }
  ],
};
